<template>
  <div class="xv_view" id="Settings">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Settings</label>
      </div>
      <div class="xv_actions"></div>
    </div>

    <div class="xv_side_menu">
      <div class="menu">
        <div>
          <button
            :class="{ active: active_sub_menu == 'employee_policies' }"
            @click="sub_menu('employee_policies')"
          >Employee Policies</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'visitor_policies' }"
            @click="sub_menu('visitor_policies')"
          >Visitor Policies</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'declaration_config' }"
            @click="sub_menu('declaration_config')"
          >Health Declarations</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'security_partners' }"
            @click="sub_menu('security_partners')"
          >Security Partners</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'company' }"
            @click="sub_menu('company')"
          >Company</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'profile' }"
            @click="sub_menu('profile')"
          >Profile</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'preferences' }"
            @click="sub_menu('preferences')"
          >Preferences</button>
        </div>
        <div>
          <button
            :class="{ active: active_sub_menu == 'alerts' }"
            @click="sub_menu('alerts')"
          >Alerts</button>
        </div>
      </div>
      <div class="content">
        <employeePolicies v-if="active_sub_menu == 'employee_policies'"></employeePolicies>
        <visitorPolicies v-if="active_sub_menu == 'visitor_policies'"></visitorPolicies>
        <declarationConfig v-if="active_sub_menu == 'declaration_config'"></declarationConfig>
        <securityPartners v-if="active_sub_menu == 'security_partners'"></securityPartners>
        <company v-if="active_sub_menu == 'company'"></company>
        <profile v-if="active_sub_menu == 'profile'"></profile>
        <preferences v-if="active_sub_menu == 'preferences'"></preferences>
        <alerts v-if="active_sub_menu == 'alerts'"></alerts>
      </div>
    </div>
  </div>
</template>

<script>
import employeePolicies from "./employee_policies/employee_policies.vue";
import visitorPolicies from "./visitor_policies/visitor_policies.vue";
import declarationConfig from "./declaration_config/declaration_config.vue";
import securityPartners from "./security_partners/security_partners.vue";
import company from "./company/company.vue";

import preferences from "./preferences/preferences.vue";
import profile from "./profile/profile.vue";
import alerts from "./alerts/alerts.vue";

export default {
  name: "Settings",
  components: {
    employeePolicies,
    visitorPolicies,
    declarationConfig,
    securityPartners,
    company,
    alerts,
    profile,
    preferences
  },
  data() {
    return {
      active_sub_menu: "employee_policies"
    };
  },
  methods: {
    sub_menu: function(menu) {
      this.active_sub_menu = menu;
    }
  }
};
</script>
